import { z } from "zod";
export const InvoiceDocumentSchema = z.object({
    id: z.string(),
    invoiceNumber: z.string(),
    issueDate: z.string(),
    kind: z.enum(["invoice", "credit"]),
    fileName: z.string(),
});
export const invoiceDocumentKeys = {
    root: ["invoice-documents"],
    customer: (customerId) => ["invoice-documents", customerId],
};
export function getInvoiceDownloadFilename(commercialName, invoiceNumber, customerLabel) {
    if (!invoiceNumber) {
        throw new Error("Invoice number is missing");
    }
    const prefix = commercialName ? `Facture_${commercialName}` : "Facture";
    return `${prefix}_${customerLabel ? `${customerLabel}_` : ""}${invoiceNumber}.pdf`;
}
//# sourceMappingURL=invoiceDocument.js.map